import { asFunction } from 'awilix';

import {
	ClueRepository,
	CrosswordBookRepository,
	CrosswordRepository,
	GridPatternRepository,
	PublicationRepository,
	TagRepository,
	ThemeRepository,
	UserRepository,
	WordClueRepository,
	WordRepository,
} from '.';

export const RepositoryDI = {
	CrosswordRepository: asFunction(CrosswordRepository),
	PublicationRepository: asFunction(PublicationRepository),
	TagRepository: asFunction(TagRepository),
	GridPatternRepository: asFunction(GridPatternRepository),
	ClueRepository: asFunction(ClueRepository),
	WordRepository: asFunction(WordRepository),
	CrosswordBookRepository: asFunction(CrosswordBookRepository),
	WordClueRepository: asFunction(WordClueRepository),
	UserRepository: asFunction(UserRepository),
	ThemeRepository: asFunction(ThemeRepository),
};
